
import { generateClassName } from '@klv/shared/utils/functions';

import { InHeroContainer } from './styles';
import * as styles from './styles/forms.module.scss';

import type { IFormWrapper } from './types';

const FormWrapper = (
  {
    backgroundColor,
    children,
    logo,
    inHero,
  }: IFormWrapper) => {
  if (inHero) {
    return <InHeroContainer>{children}</InHeroContainer>;
  }

  return (
    <>
      <div
        className={generateClassName(['grid', styles.formGrid])}
        style={{ color: backgroundColor === 'light' ? 'var(--color-charcoal)' : 'var(--color-white)' }}
      >
        <div className={styles.logoWrapper}>
          {logo}
        </div>
        <div className={styles.modalContent}>
          <div className={styles.formArea}>
            {children}
          </div>
        </div>
      </div>
      <div className={styles.bottomTriangle} />
    </>
  );
};

export default FormWrapper;
